import { useEffect, useState } from "react";

import { useLoyaltyApi } from "../useLoyaltyApi";
import { useLoyaltyRestrictedContent } from "../useLoyaltyRestrictedContent";

export const useLoyalty = () => {
  const [isActive, setIsActive] = useState(false);
  const { isRestricted, isLoyaltyEnabled } = useLoyaltyRestrictedContent();
  const loyaltyApi = useLoyaltyApi();

  useEffect(() => {
    if (isLoyaltyEnabled && !isRestricted) {
      loyaltyApi
        .getStatus()
        .then((response: boolean) => {
          setIsActive(response);
        })
        .catch(() => {
          setIsActive(false);
        });
    }
  }, [isLoyaltyEnabled, isRestricted]);

  return isActive;
};
